module.exports = __webpack_public_path__ + "img/system.c39b0cc0.png";